



















import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Rent'
})
export default class extends Vue {
  private totalCost = ''
  private moreCost = ''
  private lessCost = ''

  private calRent () {
    const total = parseFloat(this.totalCost)
    if (total >= 200) {
      const lessCost = (total - 200) / 2
      const moreCost = lessCost + 200
      this.moreCost = moreCost.toString()
      this.lessCost = lessCost.toString()
    }
  }

  private clear () {
    this.totalCost = ''
    this.moreCost = ''
  }
}
